module.exports = __webpack_public_path__ + "img/artboard-1-copia-2-100_upscayl_4x_realesrgan-x4plus.c2c447dd.png";